export const CURRENCY_FORMATS = {
    'en': { prefix: '€', suffix: '', needsWhiteSpace: false },
    'es-ar': { prefix: 'US$', suffix: '', needsWhiteSpace: true },
    'en-au': { prefix: '$', suffix: '', needsWhiteSpace: false },
    'de-at': { prefix: '', suffix: '€', needsWhiteSpace: true },
    'en-ca': { prefix: '$', suffix: '', needsWhiteSpace: false },
    'fr-ca': { prefix: '$', suffix: '', needsWhiteSpace: true },
    'es-cl': { prefix: 'CLP', suffix: '', needsWhiteSpace: true },
    'zh-cn': { prefix: '¥', suffix: '', needsWhiteSpace: false },
    'es-co': { prefix: 'COP', suffix: '', needsWhiteSpace: true },
    'en-cz': { prefix: '', suffix: 'Kč', needsWhiteSpace: true },
    'da': { prefix: '', suffix: 'DKK', needsWhiteSpace: true },
    'fi': { prefix: '', suffix: '€', needsWhiteSpace: true },
    'fr-fr': { prefix: '', suffix: '€', needsWhiteSpace: true },
    'de-de': { prefix: '', suffix: '€', needsWhiteSpace: true },
    'el': { prefix: '', suffix: '€', needsWhiteSpace: true },
    'en-hk': { prefix: '$', suffix: '', needsWhiteSpace: false },
    'en-hu': { prefix: '', suffix: 'Ft', needsWhiteSpace: true },
    'is': { prefix: '', suffix: 'ISK', needsWhiteSpace: true },
    'en-in': { prefix: '₹', suffix: '', needsWhiteSpace: false },
    'en-id': { prefix: 'Rp', suffix: '', needsWhiteSpace: true },
    'it-it': { prefix: '', suffix: '€', needsWhiteSpace: true },
    'ja': { prefix: '¥', suffix: '', needsWhiteSpace: false },
    'en-kr': { prefix: '₩', suffix: '', needsWhiteSpace: false },
    'ko-kr': { prefix: '₩', suffix: '', needsWhiteSpace: false },
    'en-my': { prefix: 'RM', suffix: '', needsWhiteSpace: true },
    'es-mx': { prefix: 'MXN$', suffix: '', needsWhiteSpace: true },
    'fr-ma': { prefix: '', suffix: 'DH', needsWhiteSpace: true },
    'nl': { prefix: '€', suffix: '', needsWhiteSpace: true },
    'en-nz': { prefix: 'NZ$', suffix: '', needsWhiteSpace: false },
    'no': { prefix: '', suffix: 'NOK', needsWhiteSpace: true },
    'es-pe': { prefix: 'S/', suffix: '', needsWhiteSpace: true },
    'en-ph': { prefix: '₱', suffix: '', needsWhiteSpace: false },
    'pl': { prefix: '', suffix: 'zł', needsWhiteSpace: true },
    'pt-pt': { prefix: '', suffix: '€', needsWhiteSpace: true },
    'en-qa': { prefix: 'QAR', suffix: '', needsWhiteSpace: true },
    'ro': { prefix: '', suffix: 'RON', needsWhiteSpace: true },
    'en-sa': { prefix: 'SAR', suffix: '', needsWhiteSpace: true },
    'en-sg': { prefix: '$', suffix: '', needsWhiteSpace: false },
    'en-za': { prefix: 'R', suffix: '', needsWhiteSpace: true },
    'es-es': { prefix: '', suffix: '€', needsWhiteSpace: true },
    'es-ca': { prefix: '', suffix: '€', needsWhiteSpace: true },
    'sv': { prefix: '', suffix: 'kr', needsWhiteSpace: true },
    'de-ch': { prefix: '', suffix: 'CHF', needsWhiteSpace: true },
    'fr-ch': { prefix: '', suffix: 'CHF', needsWhiteSpace: true },
    'it-ch': { prefix: '', suffix: 'CHF', needsWhiteSpace: true },
    'en-tw': { prefix: 'NT$', suffix: '', needsWhiteSpace: false },
    'zh-tw': { prefix: 'NT$', suffix: '', needsWhiteSpace: false },
    'en-th': { prefix: '฿', suffix: '', needsWhiteSpace: false },
    'tr': { prefix: '', suffix: 'TL', needsWhiteSpace: true },
    'ar-ae': { prefix: '', suffix: 'د.إ', needsWhiteSpace: true },
    'en-ae': { prefix: 'AED', suffix: '', needsWhiteSpace: true },
    'en-gb': { prefix: '£', suffix: '', needsWhiteSpace: false },
    'en-us': { prefix: '$', suffix: '', needsWhiteSpace: false },
    'es-us': { prefix: '$', suffix: '', needsWhiteSpace: false },
};
